export enum QueryDataMetricsEnum {
  TOTAL_SENT = 'TotalSent',
  TOTAL_CONVERSIONS = 'TotalCustomConversions',
}

type ObjectTypeOfQueryMetrics = { [value in QueryDataMetricsEnum]: { enumName: value } };

export type QueryDataMetrics = Array<ObjectTypeOfQueryMetrics[keyof ObjectTypeOfQueryMetrics]>;

export type QueryData = {
  conversionEventFilter: string;
  campaignFilters?: Record<string, any>;
  startTime: string;
  endTime: string;
  includeRevenue: boolean;
  metrics: {
    mediumMetrics: [];
    overallMetrics: QueryDataMetrics;
  };
};

export enum MetricsEnum {
  TOTAL_SENT = 'Total Sent',
  TOTAL_CONVERSIONS = 'Total Conversions',
}

export type DataPoint = {
  time: number;
  value: number;
};

export type Histogram = {
  buckets: DataPoint[];
};

export type Metric = {
  histogram: Histogram;
};

export type OverallMetrics = {
  [value in MetricsEnum]: Metric;
};

export type Dataset = {
  overallMetrics?: OverallMetrics;
};

export enum MediumEnum {
  EMAIL = 'Email',
  SMS = 'SMS',
  PUSH = 'Push',
  IN_APP = 'In-App',
  WEB_PUSH = 'Web Push',
}
